(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
// Menu au survol sur desktop
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 990) {
    const headerMenus = document.querySelectorAll('.header__inline-menu header-menu');
    
    headerMenus.forEach(menu => {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      
      // Ouvrir au survol
      menu.addEventListener('mouseenter', function() {
        details.setAttribute('open', '');
      });
      
      // Fermer quand on quitte
      menu.addEventListener('mouseleave', function() {
        details.removeAttribute('open');
      });
      
      // Empêcher le toggle au clic et permettre la navigation
      if (summary) {
        summary.addEventListener('click', function(e) {
          const link = this.querySelector('a.header__menu-item-link');
          const isCaretClick = e.target.closest('.icon-caret');
          
          // Si on clique sur le lien (pas sur la flèche)
          if (link && !isCaretClick) {
            e.preventDefault();
            window.location.href = link.href;
          } else {
            // Empêcher le toggle dans tous les cas
            e.preventDefault();
          }
        });
      }
    });

// Gérer les sous-menus de 2ème niveau
if (window.innerWidth >= 990) {
  const subMenuDetails = document.querySelectorAll('.header__submenu details');
  
  subMenuDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    
    // Ouvrir au survol
    detail.addEventListener('mouseenter', function() {
      this.setAttribute('open', '');
    });
    
    // Fermer quand on quitte
    detail.addEventListener('mouseleave', function() {
      this.removeAttribute('open');
    });
    
    // Empêcher le toggle au clic et permettre la navigation
    if (summary) {
      summary.addEventListener('click', function(e) {
        const link = this.querySelector('a.header__submenu-item-link');
        const isCaretClick = e.target.closest('.icon-caret');
        
        if (link && !isCaretClick) {
          e.preventDefault();
          window.location.href = link.href;
        } else {
          e.preventDefault();
        }
      });
    }
  });
}

  }
});

// Gérer les sous-menus de 2ème niveau
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 990) {
    const subMenuDetails = document.querySelectorAll('.header__submenu details');
    
    subMenuDetails.forEach(detail => {
      const summary = detail.querySelector('summary');
      
      // Ouvrir au survol
      detail.addEventListener('mouseenter', function() {
        this.setAttribute('open', '');
      });
      
      // Fermer quand on quitte
      detail.addEventListener('mouseleave', function() {
        this.removeAttribute('open');
      });
      
      // Rendre la sous-catégorie cliquable
      if (summary) {
        summary.addEventListener('click', function(e) {
          e.preventDefault();
          
          const isCaretClick = e.target.closest('.icon-caret');
          
          if (!isCaretClick) {
            // Récupérer l'ID du summary
            const summaryId = this.getAttribute('id');
            
            // Format: HeaderMenu-parent-child
            // On doit trouver où commence le nom de l'enfant
            // En cherchant le dernier segment après le parent
            if (summaryId) {
              // Retirer "HeaderMenu-"
              const withoutPrefix = summaryId.replace('HeaderMenu-', '');
              
              // Trouver le parent (premier élément du menu)
              const parentItem = this.closest('.header__submenu').previousElementSibling;
              const parentId = parentItem ? parentItem.getAttribute('id') : '';
              const parentHandle = parentId.replace('HeaderMenu-', '');
              
              // Retirer le parent handle du début
              const childHandle = withoutPrefix.replace(parentHandle + '-', '');
              
              const url = '/collections/' + childHandle;
              console.log('Redirecting to:', url);
              window.location.href = url;
            }
          }
        });
      }
    });
  }
});

// Gérer les sous-sous-menus de 3ème niveau
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 990) {
    const thirdLevelDetails = document.querySelectorAll('.header__submenu details details');
    
    thirdLevelDetails.forEach(detail => {
      const summary = detail.querySelector('summary');
      
      // Ouvrir au survol
      detail.addEventListener('mouseenter', function() {
        this.setAttribute('open', '');
      });
      
      // Fermer quand on quitte
      detail.addEventListener('mouseleave', function() {
        this.removeAttribute('open');
      });
      
      // Empêcher le toggle au clic
      if (summary) {
        summary.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    });
  }
});


  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
